import { InputHTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, className, ...props }, ref) => {
    return (
      <div className="space-y-2.5">
        {label && (
          <label className="font-raleway block text-base font-bold text-white">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={cn(
            "w-full rounded-full border border-white/30 bg-white/10 px-4 py-2.5 text-sm text-white placeholder-white/60 focus:border-white focus:ring-1 focus:ring-white focus:outline-none",
            className
          )}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
